module.exports = __webpack_public_path__ + "img/SNB_Premuim.cde97c2b.svg";